import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import PricingCTA from "./PricingCTA";

const PRESETS = {
  scans: {
    kicker: "Paywall Gateway",
    title: "Your celestial gate awaits",
    body: "You've used today's free scans. Unlock unlimited resonance.",
  },
  destined_cities: {
    kicker: "Subscriber-Only Insight",
    title: "Unlock your three destined cities",
    body: "Top Money, Top Love, and Top Healing cities are curated from your Jupiter, Venus and Chiron lines. Available with Solar Return or Infinity.",
  },
  generic: {
    kicker: "Choose your gate",
    title: "Unlock the full experience",
    body: "Pick a tier to continue.",
  },
};

export default function PaywallModal({ open, onClose, context = "scans" }) {
  const p = PRESETS[context] || PRESETS.generic;
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose?.()}>
      <DialogContent className="max-w-5xl bg-[#15111A] border border-[#C8A96E]/40 text-white" data-testid="paywall-modal">
        <DialogHeader>
          <div className="text-xs uppercase tracking-[0.3em] text-[#C8A96E]" data-testid="paywall-kicker">{p.kicker}</div>
          <DialogTitle className="font-heading text-3xl sm:text-4xl tracking-tighter mt-2" data-testid="paywall-title">
            {p.title}
          </DialogTitle>
          <p className="text-[#A89C98] mt-2" data-testid="paywall-body">{p.body}</p>
        </DialogHeader>

        <div className="mt-4">
          <PricingCTA compact />
        </div>
      </DialogContent>
    </Dialog>
  );
}
